import PageCompiler from '@edools/page-compiler'
import lodashCloneDeep from 'lodash.clonedeep'
import lodashMerge from 'lodash.merge'
import lodashIsEmpty from 'lodash.isempty'

const PANELS = PageCompiler.defaults.panels

export default (id, options, path, position) => {
  const panel = lodashCloneDeep(PANELS.empty)

  panel.id = id
  panel.path = path
  panel.options.sm.position = position
  panel.options.md.position = position
  panel.options.lg.position = position

  if (!lodashIsEmpty(options)) {
    lodashMerge(panel.options, options)
  }

  return panel
}
